/**
 * Created by Ning Jiang on 11/16/2018.
 */

import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {TombstoneSoundConfig} from "../TombstoneSoundConfig";

export class ShootingAnimation extends TimelineLite {

    private _hole:PIXI.Sprite;
    private _smoke:TimelineSprite;
    private _spark:TimelineSprite;

    get hole():PIXI.Sprite {
        return this._hole;
    }

    get smoke():TimelineSprite {
        return this._smoke;
    }

    get spark():TimelineSprite {
        return this._spark;
    }

    constructor(vars?:{}) {
        super(vars);
    }

    public createAnimation(holeContainer:PIXI.Container, sparkContainer:PIXI.Container, holePos:[number, number], sparkPos:[number, number]):void {
        this._hole = new PIXI.Sprite(GameResources.getTextures("bulletHole")[0]);
        this._hole.anchor.set(0.5);
        // hole.rotation = Math.random() * Math.PI * 2;
        this._hole.position.set(holePos[0], holePos[1]);
        this._hole.visible = false;
        holeContainer.addChild(this._hole);

        this._smoke = new TimelineSprite(GameResources.getTextures("holeSmoke"));
        this._smoke.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._smoke.anchor.set(0.5, 1);
        this._smoke.scale.set(2);
        this._smoke.position.set(sparkPos[0], sparkPos[1] + Math.round(this._hole.height / 2));
        this._smoke.hide();
        sparkContainer.addChild(this._smoke);

        this._spark = new TimelineSprite(GameResources.getTextures("sparkSmoke"));
        this._spark.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._spark.anchor.set(0.5);
        this._spark.position.set(sparkPos[0], sparkPos[1]);
        this._spark.hide();
        sparkContainer.addChild(this._spark);

        this.add([
            this._spark.getAnimationAutoShowHide(),
            () => {
                this._smoke.getAnimationAutoShowHide();
                SlotGame.sound.playEffect(TombstoneSoundConfig.getPistolSoundName());
            }
        ]);
        this.add(() => this._hole.visible = true, 0.05);
    }

    public reset():void {
        this._hole.visible = false;
        this._smoke.hide();
        this._spark.hide();
    }
}